import React, { MutableRefObject, useRef, useState } from 'react';

import VideocamOffIcon from '@mui/icons-material/VideocamOff';

import Player from 'video.js/dist/types/player';

import { Box, CircularProgress, Grid } from '@mui/material';

import { ALL_CAMERAS_ID } from '../VideoPlayerDialog';
import SinglePlayerForAllCameras from './SinglePlayerForAllCameras';

import ControlBar from './ControlBar';
interface IOwnProps {
    getSrcUrl: (paramName: string) => string;
    ids: string[];
    videoRef: MutableRefObject<HTMLVideoElement | null>;
    fullscreen: boolean;
    handleFullscreen: () => void;
    type: string;
}

const AllCameras = ({
    getSrcUrl,
    ids,
    videoRef,
    fullscreen,
    handleFullscreen,
    type,
}: IOwnProps) => {
    const playerRefs = useRef<{ [cameraId: string]: Player }>({});

    const [numberOfPlayersReady, setNumberOfPlayersReady] = useState(0);

    const handleSetPlayerReady = (cameraId: string, player: Player) => {
        if (!playerRefs.current[cameraId]) {
            playerRefs.current[cameraId] = player;
            setNumberOfPlayersReady((prev) => prev + 1);
        }
    };

    const actualIds = ids.filter((id) => id !== ALL_CAMERAS_ID);
    const allReady = numberOfPlayersReady === actualIds.length;

    const cameraSlots = [
        ...actualIds,
        ...Array(4 - actualIds.length).fill(null),
    ];
    return (
        <>
            {!allReady && actualIds.length > 0 && (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="400px"
                    width="100%"
                >
                    <CircularProgress size={60} />
                </Box>
            )}

            {actualIds.length > 0 && (
                <>
                    <Box sx={{ display: 'flex' }}>
                        <Grid
                            container
                            columns={36}
                            justifyContent="center"
                            alignItems="start"
                            sx={{
                                display: allReady ? 'flex' : 'none',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '95vw',
                            }}
                        >
                            {cameraSlots.map((camera, i) =>
                                camera ? (
                                    <SinglePlayerForAllCameras
                                        key={camera}
                                        cameraName={camera}
                                        videoSrc={getSrcUrl(camera)}
                                        videoRef={
                                            i === 0 ? videoRef : undefined
                                        }
                                        onPlayerReady={(player) =>
                                            handleSetPlayerReady(camera, player)
                                        }
                                        type={type}
                                        fullscreen={fullscreen}
                                    />
                                ) : (
                                    <Grid
                                        item
                                        xs={fullscreen ? 26 : 36}
                                        lg={fullscreen ? 13 : 18}
                                        key={`placeholder-${i}`}
                                        sx={{
                                            backgroundColor: 'black',
                                            minHeight: '50%',
                                            border: '1px solid gray',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <VideocamOffIcon
                                            sx={{ color: 'gray' }}
                                        />
                                    </Grid>
                                )
                            )}
                        </Grid>
                    </Box>
                    {allReady && (
                        <ControlBar
                            allReady={allReady}
                            playerRefs={playerRefs}
                            fullscreen={fullscreen}
                            handleFullscreen={handleFullscreen}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default AllCameras;
